import { CounterInputField } from "@ps-design-system/components/CounterInput";

import { useIntl } from "react-intl-compat";

/** Maximum number of guests allowed. */
const MaxGuestsField = () => {
  const intl = useIntl();

  return (
    // @ts-ignore - issues in design system
    <CounterInputField
      fullWidth
      className="tw-max-w-[300px]"
      name="numberOfGuests"
      min={0}
      label={intl.formatMessage({
        id: "hosting.listing_rules.capacity_label",
        defaultMessage: "Maximum guests",
      })}
      required
      placeholder="250"
      testId="rules-form-max-guests-input"
    />
  );
};

export { MaxGuestsField };
